import { ROUTES } from "@features/rh/config/constants";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/(dashboard)/frais/")({
  loader: () => {
    throw redirect({ to: ROUTES.RH.NOTES_DE_FRAIS.ME });
  },
});
